import { Card, Col, Empty, Row, Typography } from 'antd'
import PageTitle from '../../components/PageTitle'

const CampagnesPage = () => {
  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <PageTitle type="sympa" title="Campagnes" />
        <Card className="big-border-purple">
          <Empty
            description={
              <Typography.Text>
                Target your audience via custom messages
                <br />
                Coming soon
              </Typography.Text>
            }
          />
        </Card>
      </Col>
    </Row>
  )
}

export default CampagnesPage
